import logger from '../Common/Utils/Logger'
import { authTokenRequest, msalConfig } from './Config'
import { refreshToken, resetCredentials, selectAccount } from './Redux/Auth'
import { PublicClientApplication } from '@azure/msal-browser'
import { request } from '../Common/Utils/Api'
import api from '../Core/Services/Api'
import history from '../Core/history'
import config from '../Core/Config'
import store from '../Core/Redux/Store'

export const msalInstance = new PublicClientApplication(msalConfig)

export const logout = (dispatch, completeInit = () => {}) => {
  msalInstance
    .logoutPopup()
    .then(() => {
      dispatch(resetCredentials())
      history.push(config.urls.login)
      completeInit()
    })
    .catch((err) => {
      logger.warning('Logout flow error:', err)
    })
}

export const fetchUser = async (userName) => {
  try {
    const res = await request(api.users.get, [userName], null, null)

    if (res.response?.statusCode >= 400) {
      history.push(config.urls.forbidden.replace(':error', 'user'))
    } else if (!res.isSuccessful) {
      history.push(config.urls.serverError.replace(':error', 'user'))
    }

    return res.response.data
  } catch (e) {
    logger.error('Fetch current user error: ', e)
    history.push(config.urls.serverError.replace(':error', 'user'))
  }
}

export const refreshJwt = async () => {
  const account = selectAccount(store.getState())
  logger.info('Refreshing JWT for account', account)
  return msalInstance
    .acquireTokenSilent({ ...authTokenRequest, account })
    .then(async (response) => {
      logger.info('JWT retrieved - silent')
      store.dispatch(refreshToken(response.accessToken))
      api.setAuthToken(response.accessToken)
      return response.accessToken
    })
    .catch(async (err) => {
      logger.info('JWT acquire token silent failed, going for popup', err)
      msalInstance
        .acquireTokenPopup(authTokenRequest)
        .then(async (response) => {
          logger.info('JWT retrieved - popup')
          store.dispatch(refreshToken(response.accessToken))
          api.setAuthToken(response.accessToken)
          return response.accessToken
        })
        .catch((err) => {
          logger.error('Get jwt error:', err)
          history.push(config.urls.serverError.replace(':error', 'token'))
        })
    })
}
